import './style.less';

export default function ($rootScope, ModalService) {
    return {
        link: function (scope, element, attr) {
            scope.$watch(attr.sidebar, function(newVal) {
                if(newVal)
                {
                    element.addClass('show');
                    return;
                }
                element.removeClass('show');
            });
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/directives/sidebar/index.js